import React from 'react';
import ButtonAction from '../ButtonAction';
import { ButtonGroup, Button } from 'reactstrap';

export default class ElementCountListItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      count: this.props.count
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.count !== this.state.count) {
      this.updateCount(nextProps.count);
    }
  }

  getCount() {
    return this.state.count;
  }

  increment = () => {
    if (this.state.count < this.props.max) {
      this.updateCount(this.state.count + 1);
    }
  }

  decrement = () => {
    if (this.state.count > 0) {
      this.updateCount(this.state.count - 1);
    }
  }

  setMax = () => {
    this.updateCount(this.props.max);
  }

  setMin = () => {
    this.updateCount(0);
  }

  updateCount(count) {
    this.setState({count});
    this.props.update(count);
  }

  render() {
    return (
      <ButtonGroup
        size='sm'
        className='sample-counter-item'
      >
        <Button
          onClick={this.setMin}
          title='set count to zero'
        >
          None
        </Button>
        <ButtonAction
          icon='fa-minus'
          color='secondary'
          action={this.decrement}
          title='decrement count'
        />
        <Button
          className='sample-counter-count'
          title='current count'
          active={false}
        >
          {this.state.count}
        </Button>
        <ButtonAction
          icon='fa-plus'
          color='secondary'
          title='increment count'
          action={this.increment}
        />
        <Button
          onClick={this.setMax}
          title={`set count to ${this.props.max}`}
        >
          All
        </Button>
      </ButtonGroup>
    );
  }
}
